export default __webpack_public_path__ + "images/RI.ed1c2c7.png";